export default {
  profiles: [],
  profileFields: {},
  profileFilters: {
    demographicFilters: {
      genderFilters: [],
      ethnicityFilters: [],
      languageFilters: [],
      locationFilters: [],
      contactFilters: [],
      channelsUsedFilters: [],
      engagedDates: [],
      duringWhichShowFilters: [],
      ageFilters: [],
    },
    campaignSurveyFilters: [],
  },
  profileFilterFields: {},
  selectedProfile: {},
  loadingProfiles: false,
  loadProfilesFailed: false,
  loadProfilesSuccess: false,
  profileDialogVisible: false,
  page: 1,
  profilesCount: 0,
  showDisplayProfiles: false,
  isSearching: false,
  searchQuery: null,

  loadingProfileIdentity: false,
  loadProfileIdentityFailed: false,
  loadProfileIdentitySuccess: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/state.js